import { useNavigate } from 'react-router-dom';
import { STACK_ITEMS } from './data';

export default function StackedSection() {
  const navigate = useNavigate();

  return (
    <section id="como-funciona" className="scroll-mt-28 bg-secondary-50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1240px] px-6">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.22em] text-primary-700">
            Como funciona
          </span>
          <h2 className="mt-5 font-heading text-3xl font-bold leading-[1.1] tracking-[-0.02em] text-foreground-950 md:text-5xl">
            Não somos só plataforma, somos <span className="text-primary-600">parceiros estratégicos</span>
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-foreground-600">
            Gestão simples para o time interno e uma experiência envolvente para quem está na ponta. Tudo conectado em um único lugar.
          </p>
          <button
            type="button"
            onClick={() => navigate('/plataforma')}
            className="mx-auto mt-6 inline-flex h-11 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full border border-primary-300 bg-background-50 px-6 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-50"
          >
            Conheça a plataforma completa
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>

      <div className="mx-auto mt-12 w-full max-w-[1240px] px-6 md:mt-16">
        <img
          src="https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/c15b60728852798b1d816fc65463c379.png"
          alt="Como funciona o GetPoints: estratégia personalizada, implementação ágil, gestão em tempo real e engajamento do público"
          title="Como funciona - GetPoints"
          className="mx-auto block h-auto w-full"
        />
      </div>

      <div className="mt-4 hidden lg:block">
        <div className="mx-auto w-full max-w-[1240px] px-6">
          {STACK_ITEMS.map((item, index) => (
            <div key={item.badge} className="sticky top-0 flex h-screen items-center" style={{ zIndex: index + 1 }}>
              <article
                style={{ marginTop: index * 12 }}
                className={`w-full overflow-hidden rounded-[2rem] border border-background-200 ${
                  item.tone === 'soft' ? 'bg-secondary-100' : 'bg-background-50'
                }`}
              >
                {item.fullImage ? (
                  <img
                    src={item.image}
                    alt={item.title}
                    className="block h-auto w-full object-cover"
                  />
                ) : (
                <div className="grid items-center gap-8 p-8 lg:grid-cols-2 lg:p-12">
                  <div className="flex flex-col justify-center">
                    <span className="inline-flex w-fit items-center rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-primary-700">
                      {item.badge}
                    </span>
                    <h3 className="mt-6 font-heading text-2xl font-bold leading-tight tracking-[-0.02em] text-foreground-950 lg:text-4xl">
                      {item.title}
                    </h3>
                    <p className="mt-5 max-w-lg text-sm leading-relaxed text-foreground-600 lg:text-base">
                      {item.description}
                    </p>
                    <button
                      type="button"
                      onClick={() => navigate('/solicitar-demo')}
                      className="mt-8 inline-flex h-11 w-fit cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
                    >
                      {item.cta}
                      <i className="ri-arrow-right-line"></i>
                    </button>
                  </div>

                  <div className="relative h-[300px] overflow-hidden rounded-3xl border border-background-200 sm:h-[380px] lg:h-[440px]">
                    <img src={item.image} alt={item.title} className="absolute inset-0 h-full w-full object-cover object-top" />
                  </div>
                </div>
                )}
              </article>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-12 lg:hidden">
        <div className="lp-scroll-hide flex snap-x snap-mandatory gap-4 overflow-x-auto px-6 pb-4">
          {STACK_ITEMS.map((item) => (
            <article
              key={item.badge}
              className="w-[86vw] max-w-[420px] shrink-0 snap-start overflow-hidden rounded-3xl border border-background-200 bg-background-50"
            >
              {item.fullImage ? (
                <img
                  src={item.image}
                  alt={item.title}
                  className="block h-auto w-full object-cover"
                />
              ) : (
              <>
              <div className="relative h-[220px] overflow-hidden">
                <img src={item.image} alt={item.title} className="absolute inset-0 h-full w-full object-cover object-top" />
              </div>
              <div className="p-6">
                <span className="inline-flex items-center rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.2em] text-primary-700">
                  {item.badge}
                </span>
                <h3 className="mt-4 font-heading text-xl font-bold leading-snug text-foreground-950">{item.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{item.description}</p>
                <button
                  type="button"
                  onClick={() => navigate('/solicitar-demo')}
                  className="mt-5 inline-flex h-10 cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
                >
                  {item.cta}
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
              </>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}